export function currentAnimationTimeMillis() {
  return Date.now();
}



// WEBPACK FOOTER //
// ./node_modules/react-native-scroller/library/AnimationUtils.js